import { Tooltip, Badge, Popup, Icon, VerticalMenu } from '@scuf/common';
import { DataTable } from '@scuf/datatable';
import i18next from 'i18next';
import moment from 'moment';
import { useState, useEffect } from 'react';
import { IColumn } from '../../../../components/FilterPopup/FilterPopup';
import { ICellData } from '../../onboardingUtils';
import { AlertModal } from '../AlertModal';
import { dateFormat } from './SKUList';
import {
  IFilterSubscriptionList,
  SUBSCRIPTION_NOTIFY_PRIOR_DAYS
} from './SKUModels';

const FilterSubscriptionList = (propsFilter: IFilterSubscriptionList) => {
  const validTillBefore = new Date();
  validTillBefore.setDate(
    validTillBefore.getDate() + SUBSCRIPTION_NOTIFY_PRIOR_DAYS
  );
  const [selectedSKUForRenew, setSelectedSKUForRenew] = useState<string>();
  const [showRenewModal, setShowRenewModal] = useState<boolean>(false);
  const [itemsPerPage] = useState<number>(10);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  useEffect(() => {
    if(isOpen === true){
      setIsOpen(false);
    }
  }, [isOpen])
  
  return (
    <>
      <DataTable
        data={propsFilter.subscriptionList}
        reorderableColumns={true}
        scrollable={true}
        search={false}
        loading={propsFilter.isLoading}
        resizableColumns={true}
      >
        <DataTable.HeaderBar />
        {propsFilter.filteredColumns &&
          propsFilter.filteredColumns.map((column: IColumn) => {
            return (
              <DataTable.Column
                key={column.name}
                field={column.fieldName}
                header={i18next.t(column.name)}
                sortable={column.sortable}
                renderer={(item: ICellData) => {
                  switch (column.fieldName) {
                    case 'skuName':
                      const cellClassName = `ui ${
                        item.rowData.utilizedQuantity === 0 ? 'red' : ''
                      } circular empty label badge  circle-padding`;
                      const isSubscriptionExpired =
                        new Date(item.rowData.validTill).getTime() < Date.now();
                      const elementClass = !isSubscriptionExpired
                        ? 'display-label'
                        : 'display-label disabled';
                      return (
                        <div
                          className={elementClass}
                          onClick={() => {
                            if (!isSubscriptionExpired) {
                              propsFilter.setSelectedRow(item.rowData);
                            }
                          }}
                        >
                          <div className={cellClassName} />
                          <span>&nbsp;{item.value}</span>
                        </div>
                      );
                    case 'skuDescription':
                      const descLength: number = 36;
                      return item.value.length > descLength ? (
                        <Tooltip
                          element={
                            <div className="subscription-desc-data">
                              {item.value}
                            </div>
                          }
                          content={item.value}
                          size="mini"
                          position="top right"
                        />
                      ) : (
                        <div> {item.value}</div>
                      );
                    case 'utilizedQuantity':
                      return (
                        <div>
                          {item.rowData.utilizedQuantity +
                            ' / ' +
                            item.rowData.totalQuantity}{' '}
                          {i18next.t('utilized')}
                        </div>
                      );
                    case 'validTill':
                      if (
                        new Date(item.value).getTime() <
                        validTillBefore.getTime()
                      ) {
                        if (new Date(item.value).getTime() < Date.now()) {
                          return (
                            <Badge color="red">
                              {moment(item.value).utc().format(dateFormat)}
                            </Badge>
                          );
                        } else {
                          let diff = Math.ceil(
                            moment(item.value).diff(new Date(), 'days', true)
                          );
                          return (
                            <Badge color="red">
                              {diff + ' ' + i18next.t('daysRemaining')}
                            </Badge>
                          );
                        }
                      } else {
                        return <> {moment(item.value).utc().format(dateFormat)}</>;
                      }
                    case 'orderPlacedBy':
                      return <div>{item.rowData.orderPlacedBy || '-'}</div>;
                    case 'action':
                      return isOpen === false ? (
                        <Popup
                          className="popup-theme-wrap"
                          element={
                            <Icon
                              root="common"
                              name="ellipsis-horizontal"
                              size="large"
                              className={
                                !propsFilter.editSKUPermission
                                  ? 'popup-disbaled'
                                  : ''
                              }
                            />
                          }
                          on="click"
                          disabled={!propsFilter.editSKUPermission}
                        >
                          <VerticalMenu>
                            <VerticalMenu>
                              {new Date(item.rowData.validTill).getTime() >
                                Date.now() && (
                                  <VerticalMenu.Item
                                    icon="edit"
                                    iconRoot="common"
                                    onClick={() => {
                                      setIsOpen(true);
                                      propsFilter.setSelectedRow(item.rowData);
                                    }}
                                    disabled={!propsFilter.editSKUPermission}
                                  >
                                    {i18next.t('editSKU')}
                                  </VerticalMenu.Item>)
                              }
                              {new Date(item.rowData.validTill).getTime() <
                                Date.now() && (
                                  <VerticalMenu.Item
                                    icon="refresh"
                                    disabled={!propsFilter.editSKUPermission}
                                    iconRoot="common"
                                    onClick={() => {
                                      setIsOpen(true);
                                      setSelectedSKUForRenew(
                                        item.rowData.skuName
                                      );
                                      setShowRenewModal(true);
                                    }}
                                  >
                                    {i18next.t('renewSubscription')}
                                  </VerticalMenu.Item>
                                )}
                            </VerticalMenu>
                          </VerticalMenu>
                        </Popup>
                      ) : <Icon
                        root="common"
                        name="ellipsis-horizontal"
                        size="large"
                      />;
                    default:
                      return <div>{item.value}</div>;
                  }
                }}
              />
            );
          })}
        <DataTable.Pagination
          totalItems={propsFilter.subscriptionList.length}
          itemsPerPage={itemsPerPage}
        />
      </DataTable>
      {showRenewModal && (
        <AlertModal
          onClose={() => {
            setShowRenewModal(false);
          }}
          message={i18next.t('renewSubscriptionMessage', {
            skuName: selectedSKUForRenew
          })}
        />
      )}
    </>
  );
};

export default FilterSubscriptionList;
